export default __webpack_public_path__ + "static/media/page31.a1698466.jpg";